module.exports = __webpack_public_path__ + "img/product32_img06.6f0a1609.png";